import { render } from "./LatestMovies.vue?vue&type=template&id=f0c7c986&ts=true"
import script from "./LatestMovies.vue?vue&type=script&lang=ts"
export * from "./LatestMovies.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__